<template>
  <div class="mui-chip" :class="{ 'mui-chip--active': Boolean(active) }">
    <span class="mui-chip__text">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: [
    'url',
    'active'
  ]
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.mui-chip
  align-items: center
  background: #fff
  border: 1px solid rgba(0, 0, 0, 0.12)
  border-radius: 24px
  box-sizing: border-box
  cursor: pointer
  display: inline-block
  font-family: $uiFontFamily
  justify-content: center
  line-height: 14px
  margin: 0 8px 8px 0
  outline: 0
  overflow: hidden
  padding: 6px 10px
  user-select: none
  &:hover
    background: rgba(0, 0, 0, 0.12)
    .mui-chip__text
      color: #181d23
.mui-chip__text
  color: #56687e
  font-size: 11px
  font-weight: 600
  text-transform: uppercase
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
.mui-chip--active
  background: #e5f3f9
  border-color: #56687e
  color: #181d23
</style>



// WEBPACK FOOTER //
// src/components/MUIChip.vue